<div class="chat-solicitacao" [class.fill]="fillHeight">
  <div class="chat-header">
    <fa-icon [icon]="faComments"></fa-icon>
    <span>Mensagens</span>
  </div>

  <div #messagesContainer class="chat-messages">
    <p *ngIf="messages.length === 0" class="chat-empty">Nenhuma mensagem ainda.</p>

    <div
      *ngFor="let message of messages"
      class="chat-message"
      [class.mine]="isMine(message)"
      [class.theirs]="!isMine(message)"
    >
      <div class="chat-bubble">
        <div class="chat-sender">{{ message.senderDisplayName }}</div>

        <p *ngIf="message.text" class="chat-text">{{ message.text }}</p>

        <a
          *ngIf="message.messageType === MessageType.Arquivo && message.fileUrl"
          class="chat-file"
          [href]="message.fileUrl"
          target="_blank"
          rel="noopener"
        >
          <fa-icon [icon]="faPaperclip"></fa-icon>
          {{ message.fileName || 'Arquivo' }}
        </a>

        <div class="chat-meta">{{ message.createdAt | date: 'dd/MM/yyyy HH:mm' }}</div>
      </div>
    </div>
  </div>

  <div class="chat-input" *ngIf="!readOnly">
    <label class="chat-attach" title="Anexar arquivo">
      <fa-icon [icon]="faPaperclip"></fa-icon>
      <input type="file" hidden (change)="onFileSelected($event)" [disabled]="sending" />
    </label>

    <input
      type="text"
      class="chat-textbox"
      placeholder="Digite sua mensagem..."
      [(ngModel)]="draft"
      (keyup.enter)="onSubmit()"
      [disabled]="sending"
    />

    <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="sending || !draft.trim()">
      Enviar
    </button>
  </div>

  <p class="chat-closed" *ngIf="readOnly">
    Esta solicitação está encerrada. O histórico está disponível apenas para consulta.
  </p>
</div>
